import React from 'react';
import {connect} from 'react-redux';
import {LineupPlayers as BaseLineupPlayers} from 'components/organisms/lineup/components/lineup-players';
import {round} from 'helpers/number-helper';
import Const from 'constants';

class LineupPlayersComponent extends BaseLineupPlayers {
    render() {
        const {lineups, lineupId} = this.props;
        const lineup = lineups.getLineup(lineupId);

        if (!lineup) {
            return null;
        }

        let rows = [];
        lineup.players.map((player) => {
            const rowClassName = this.getRowClassName(player);

            rows.push(
                <tr key={player.playerId} className={rowClassName}>
                    <td>T{player.rosterPositionName}</td>
                    <td>
                        <strong className="player-name">{player.name}</strong>
                    </td>
                    <td>{round(player.lineupPoints, Const.POINTS_DECIMAL_PRECISION)}</td>
                    <td>{player.projOwn.getValue()}%</td>
                </tr>,
            );
        });

        return (
            <table className="table">
                <tbody>{rows}</tbody>
            </table>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {lineups},
        filterLineupsByPlayer,
    } = state;
    return {
        lineups,
        filterLineupsByPlayer,
    };
}

const LineupPlayers = connect(mapStatesToProps)(LineupPlayersComponent);

export {LineupPlayers};
